const firebaseConfig = {
    apiKey: "AIzaSyCE7oajip9NpZo5lcXyretSMYST_Q20d0M",
    authDomain: "hr-product-d81fd.firebaseapp.com",
    projectId: "hr-product-d81fd",
    storageBucket: "hr-product-d81fd.appspot.com",
    messagingSenderId: "280795600639",
    appId: "1:280795600639:web:13412852b2c5ca82865eca"
};
export default firebaseConfig;